import { render, staticRenderFns } from "./AppointmentDesktopRow.vue?vue&type=template&id=0d36f2fd"
import script from "./AppointmentDesktopRow.vue?vue&type=script&lang=js"
export * from "./AppointmentDesktopRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports